var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFpch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1908,
    height: 562,
    viewBox: "0 0 1908 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.848 204.833 348.895 6.408v113.386L6.848 318.219z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.848 204.833 348.895 6.408v113.386L6.848 318.219z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.719 51.402 205.397 118.627v113.385L408.719 164.787z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.719 51.402 205.397 118.627v113.385L408.719 164.787z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.471 199.808 408.358 51.306v113.386L152.471 313.194z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.471 199.808 408.358 51.306v113.386L152.471 313.194z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.471 199.873 68.25 38.592v113.386l-68.25-38.593z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.471 199.873 68.25 38.592v113.386l-68.25-38.593z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.419 238.431 157.098-91.184v113.385l-157.098 91.185z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.419 238.431 157.098-91.184v113.385l-157.098 91.185z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.865 147.438 68.25 38.592v113.386l-68.25-38.593z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.865 147.438 68.25 38.592v113.386l-68.25-38.593z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.799 277.565 157.098-91.184v113.386l-157.098 91.184z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.799 277.565 157.098-91.184v113.386l-157.098 91.184z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432.611 272.597 181.607-102.523v113.385L432.611 385.983z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.611 272.597 181.607-102.523v113.385L432.611 385.983z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432.613 272.878 139.652 78.711v113.386l-139.652-78.711z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.613 272.878 139.652 78.711v113.386l-139.652-78.711z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.718 277.78 207.773 118.253v113.386L288.718 391.166z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.718 277.78 207.773 118.253v113.386L288.718 391.166z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m417.729 441.524 77.509-44.769v113.386l-77.509 44.769z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.729 441.524 77.509-44.769v113.386l-77.509 44.769z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.41 205.186 410.458 236.357v113.386L6.409 318.571z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.41 205.186 410.458 236.357v113.386L6.409 318.571z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m572.547 351.59 150.601-87.856 36.075 35.369-36.075 78.017-150.601 87.855z",
    fill: "#d10c33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.547 351.59 150.601-87.856 36.075 35.369-36.075 78.017-150.601 87.855z",
    stroke: "#fff",
    strokeWidth: 12.661,
    strokeMiterlimit: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M896.044 55.22v54.574h44.687v34.419h-44.687v90.544h-34.353V20.801h86.022V55.22zm124.286 182.018c-15.83 0-28.489-5.375-37.985-16.125q-14.243-16.434-14.243-48.682V83.127q0-32.868 14.243-48.992c9.496-10.75 22.155-16.125 37.985-16.125q23.745 0 37.98 16.125 14.25 16.124 14.25 48.992v89.304c0 21.499-4.84 37.726-14.53 48.682-9.49 10.75-22.06 16.125-37.7 16.125m.28-20.466c10.05 0 17.78-3.617 23.18-10.853 5.59-7.442 8.38-18.501 8.38-33.178V85.298q0-23.565-8.1-35.04-8.1-11.782-23.46-11.782-16.2 0-24.3 11.473-7.82 11.472-7.82 35.349v87.443q0 44.031 32.12 44.031m134.62-75.66h-31v93.645h-20.39V20.801h50.83q25.41 0 36.87 14.884 11.73 14.883 11.73 45.582c0 30.594-9.5 49.406-28.49 56.434l34.07 97.056h-21.78zm-31-19.845h30.16q14.805 0 21.51-9.923c4.65-6.821 6.98-16.847 6.98-30.077 0-13.437-2.24-23.463-6.71-30.078q-6.42-10.233-21.78-10.233h-30.16zM1370 20.8v213.957h-20.39V70.414l-39.66 114.73h-13.4l-39.66-113.8v163.413h-20.39V20.801h20.39l46.64 132.094 46.08-132.094zm109.21 159.382h-56.42l-12.29 54.575h-21.23l52.51-213.956h18.71L1513 234.757h-21.51zm-4.47-19.535L1451 54.91l-23.74 105.737zM1638.96 20.8v213.957h-20.39l-65.91-164.343v164.343h-20.39V20.801h20.39l65.91 164.653V20.801zm33.52 0h49.99c15.64 0 28.21 5.375 37.7 16.125q14.25 16.124 14.25 48.683v84.342q0 32.248-14.25 48.682c-9.49 10.75-22.06 16.125-37.7 16.125h-49.99zm49.99 193.801c10.05 0 17.78-3.721 23.18-11.163 5.59-7.441 8.38-18.501 8.38-33.178V87.778q0-23.565-8.1-35.039-8.1-11.783-23.46-11.783h-29.61v173.645zm133.22 22.637q-23.745 0-37.98-16.125-14.25-16.434-14.25-48.682V83.127q0-32.868 14.25-48.992 14.235-16.125 37.98-16.125t37.98 16.125q14.25 16.124 14.25 48.992v89.304c0 21.499-4.84 37.726-14.53 48.682-9.49 10.75-22.06 16.125-37.7 16.125m.28-20.466c10.05 0 17.78-3.617 23.18-10.853 5.59-7.442 8.38-18.501 8.38-33.178V85.298q0-23.565-8.1-35.04-8.1-11.782-23.46-11.782-16.2 0-24.3 11.473c-5.21 7.648-7.82 19.431-7.82 35.349v87.443c0 29.354 10.71 44.031 32.12 44.031m-942.33 97.404q28.487 0 40.497 16.745 12.289 16.744 12.289 50.543 0 34.108-12.568 50.853-12.29 16.744-40.218 16.744h-17.875v79.071h-34.074V314.176zm-1.118 100.466q10.893 0 15.082-8.062 4.469-8.062 4.469-25.116t-4.469-25.117q-4.19-8.062-15.082-8.062h-16.757v66.357zm95.518-80.31v74.729h56.42v20.465h-56.42v78.451h65.63v20.155h-85.738V314.176h85.738v20.156zm143.84 100.156h-31.01v93.644h-20.38V314.176h50.83c16.94 0 29.23 4.962 36.86 14.884q11.73 14.885 11.73 45.582c0 30.595-9.49 49.406-28.48 56.435l34.07 97.055h-21.79zm-31.01-19.846h30.17c9.87 0 17.03-3.307 21.5-9.922 4.66-6.822 6.98-16.848 6.98-30.078 0-13.437-2.23-23.463-6.7-30.078q-6.42-10.233-21.78-10.232h-30.17zm157.52 115.971c-16.57 0-29.69-5.168-39.38-15.504q-14.52-15.814-14.52-45.892v-96.435q0-30.388 15.36-45.892 15.36-15.814 40.5-15.814 24.015 0 38.82 15.504c9.87 10.336 14.8 26.047 14.8 47.132v6.512h-34.35v-6.202c0-9.716-1.86-16.848-5.59-21.395q-5.295-7.132-14.52-7.132c-7.26 0-12.57 2.79-15.92 8.372-3.16 5.581-4.75 13.954-4.75 25.116v85.893q0 31.318 20.67 31.318 9.225 0 14.52-7.132c3.73-4.754 5.59-11.783 5.59-21.085v-5.582h34.07v5.892c0 20.672-5.21 36.279-15.64 46.822q-15.36 15.504-39.66 15.504m132.95 0c-15.83 0-28.49-5.375-37.99-16.124-9.49-10.956-14.24-27.184-14.24-48.683v-89.303c0-21.913 4.75-38.244 14.24-48.993 9.5-10.75 22.16-16.124 37.99-16.124q23.73 0 37.98 16.124c9.5 10.749 14.24 27.08 14.24 48.993v89.303q0 32.249-14.52 48.683c-9.49 10.749-22.06 16.124-37.7 16.124m.28-20.465c10.05 0 17.78-3.618 23.18-10.853 5.58-7.442 8.38-18.502 8.38-33.179v-87.443q0-23.565-8.1-35.039-8.1-11.783-23.46-11.783-16.2 0-24.3 11.473c-5.22 7.649-7.82 19.432-7.82 35.349v87.443c0 29.354 10.7 44.032 32.12 44.032m134.62-75.66h-31.01v93.644h-20.38V314.176h50.83c16.94 0 29.23 4.962 36.86 14.884q11.73 14.885 11.73 45.582c0 30.595-9.49 49.406-28.48 56.435l34.07 97.055h-21.79zm-31.01-19.846h30.17c9.87 0 17.03-3.307 21.5-9.922q6.99-10.233 6.99-30.078c0-13.437-2.24-23.463-6.71-30.078q-6.42-10.233-21.78-10.232h-30.17zm150.82 115.661c-16.38 0-28.86-5.168-37.42-15.504-8.38-10.336-12.76-25.427-13.13-45.272h19.83c.56 14.471 3.44 24.91 8.66 31.318 5.4 6.202 13.03 9.303 22.9 9.303 10.05 0 17.5-3.101 22.34-9.303 5.03-6.408 7.54-16.124 7.54-29.147 0-11.37-2.23-19.949-6.7-25.737q-6.42-8.682-23.46-16.434l-11.17-4.962c-12.66-5.581-22.16-12.713-28.49-21.395s-9.5-20.362-9.5-35.039c0-17.365 4.38-31.215 13.13-41.551 8.94-10.336 21.13-15.504 36.59-15.504 14.71 0 26.34 4.858 34.91 14.573 8.56 9.51 13.22 23.877 13.96 43.102h-19.27q-1.95-37.52-29.88-37.52c-9.68 0-16.94 3.101-21.79 9.302q-7.26 9.303-7.26 26.357c0 10.13 2.14 18.088 6.43 23.876 4.46 5.789 12.01 10.957 22.62 15.505l11.45 4.961c12.85 5.581 22.53 12.92 29.05 22.016 6.51 9.095 9.77 21.809 9.77 38.14 0 18.811-4.37 33.385-13.13 43.721q-13.125 15.194-37.98 15.194m79.6-216.127h20.11v213.956h-20.11z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0.451,
    y: 0.013,
    width: 354.839,
    height: 324.602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 402.323,
    y: 45.006,
    width: 218.189,
    height: 244.804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 146.075,
    y: 44.91,
    width: 268.679,
    height: 274.679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 146.075,
    y: 193.477,
    width: 81.042,
    height: 164.769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 214.023,
    y: 140.851,
    width: 169.89,
    height: 217.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 371.469,
    y: 141.043,
    width: 81.042,
    height: 164.769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 282.403,
    y: 179.985,
    width: 169.89,
    height: 217.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 426.215,
    y: 163.678,
    width: 194.399,
    height: 228.701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 426.217,
    y: 266.483,
    width: 152.444,
    height: 204.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 282.322,
    y: 271.385,
    width: 220.566,
    height: 244.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 411.332,
    y: 390.359,
    width: 90.302,
    height: 170.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 0.013,
    y: 198.79,
    width: 423.25,
    height: 362.535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 566.151,
    y: 257.338,
    width: 199.469,
    height: 214.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.033,
    result: "effect1_foregroundBlur_1325_5650"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1907.92v561.338H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFpch);
export default __webpack_public_path__ + "static/media/logoFPCH.a452bf682faa36424204de9948ba9005.svg";
export { ForwardRef as ReactComponent };